import isEqual from 'lodash/isEqual';
import type { Attribute } from '@placer-ui/types';
import type { ReportEntity } from 'core/entities/report/report-entity';

export const selectStarredReportAttributeCount = (entities: ReportEntity[]) => {
    const uniqueAttributesList = entities.reduce((accumulator, entity) => {
        entity.filters.attributes?.forEach((attribute) => {
            if (attribute !== 'all' && !accumulator.some((attr) => isEqual(attr, attribute))) {
                accumulator.push(attribute);
            }
        });

        return accumulator;
    }, [] as Attribute[]);

    return uniqueAttributesList.length;
};
